import React, { useCallback, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import App from './App';
import Auth from './pages/Auth';
import { StoreProvider } from './state/store';
import { loadSession, logout } from './state/api';

function Root() {
  const [session, setSession] = useState(() => loadSession());

  const onAuthed = useCallback(() => {
    setSession(loadSession());
  }, []);

  const onLogout = useCallback(() => {
    logout();
    setSession(null);
  }, []);

  useEffect(() => {
    const onSession = () => setSession(loadSession());
    window.addEventListener('bridge45:session', onSession);
    return () => window.removeEventListener('bridge45:session', onSession);
  }, []);

  if (!session) {
    return <Auth onAuthed={onAuthed} />;
  }

  return (
    <StoreProvider key={session.orgId}>
      <App onLogout={onLogout} session={session} />
    </StoreProvider>
  );
}

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
